import { Either } from "src/base/Either";
import { Failure } from "src/base/Failure";
import { UseCase } from "src/base/UseCase";
import { ISubscriptionRepository } from "../../data/repositories/subscriptionRepository";

export class AddPlan extends UseCase<AddPlanParams, boolean> {
  private repository: ISubscriptionRepository;
  constructor(repository: ISubscriptionRepository) {
    super();
    this.repository = repository;
  }

  call(params: AddPlanParams): Promise<Either<Failure, boolean>> {
    return this.repository.createPlan(params.id, params.card_id);
  }
}

export class AddPlanParams {
  id: string;
  card_id: string;
  constructor(id: string, card_id: string) {
    this.id = id;
    this.card_id = card_id;
  }
}
